export const WizardTherapyType = {
  Individual: 'individual',
  FamilyChild: 'family_child',
  FamilyPartner: 'family_partner'
}
